import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ShareIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M4.43303 5.48195L8.84309 1.0719L13.2531 5.48195M8.84309 1.0719L8.84309 11.1782M0.757978 11.1782L0.757978 15.2207C0.757978 16.3371 1.66293 17.242 2.77925 17.242L14.9069 17.242C16.0232 17.242 16.9282 16.3371 16.9282 15.2207L16.9282 11.1782"
      stroke={color}
      strokeWidth="1.5"
    />
  </Svg>
);

ShareIcon.displayName = 'ShareIcon';
